export default __webpack_public_path__ + "static/six-640b932ae0194938d1ae7ebbebc5c8f6.jpg";